/**
 * Which Lightspeed account's item-staging pipeline the current page works on.
 *
 * The staging dashboard and its tabs were built for Vaperite and talk to
 * `vaperite/staging/...`. Deeliver now has the same pipeline (Jason, 23 Oct 2026): the same
 * components are mounted at /deeliver/staging and must talk to `deeliver/staging/...`, whose
 * backend keeps Deeliver's queue, rules and lists in their own schema. The org is read from
 * the route, so every component (dashboard, tabs, dialogs) agrees without prop plumbing:
 * react-admin uses a hash router, so the route is in location.hash.
 */
export type StagingOrg = 'vaperite' | 'deeliver';

export function stagingOrg(): StagingOrg {
  if (typeof window === 'undefined') return 'vaperite';
  const route = (window.location.hash || '').replace(/^#/, '') || window.location.pathname || '';
  return route.startsWith('/deeliver/') ? 'deeliver' : 'vaperite';
}

/** The API prefix for the current org: 'vaperite' or 'deeliver'. */
export const stagingApiBase = (): string => stagingOrg();

/** "Vaperite" / "Deeliver", for titles and copy. */
export const stagingOrgLabel = (): string => (stagingOrg() === 'deeliver' ? 'Deeliver' : 'Vaperite');

/** The route the dashboard lives at for the current org. */
export const stagingRoute = (): string => `/${stagingOrg()}/staging`;
